import { React } from 'react';
import {
    Box,
    Flex,
    Container,
    Stack,
    Heading,
    Text,
    Link,
    Image
} from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons'

export default function Board() {
    return (
        <>
            <Box position={'relative'}>
                <Container maxW={'8xl'} zIndex={10} position={'relative'}>
                    <Stack
                        flex={1}
                        color={'mkyfive.50'}
                        justify={{ lg: 'center' }}
                        py={{ base: 4, md: 10, xl: '1em' }}
                    >
                        <Box mb={{ base: 8, md: 8 }}>
                            <Container
                                py={3}
                                maxW={'8xl'}
                                zIndex={10}
                                position={'relative'}
                                bg={'mkyfive.50'}
                                borderRadius={'xl'}
                                boxShadow="dark-lg"
                            >
                                <Image src="https://marketocracy-io.s3.us-east-2.amazonaws.com/box-top.png" alt="Marketocrcy Board Game Box Top"/>
                            </Container>
                        </Box>
                    </Stack>
                </Container>
            </Box>
        </>
    );
}